import * as React from "react";
import {Icon, IConcreteIcon} from "../Icon";

export const ElectronicCashIcon = ({style}: IConcreteIcon) => <Icon file="/icons/payment_methods/ec.svg" style={style} />;
